const CARD_CONFIG = [
  { label: 'Total prospects', key: 'total' },
  { label: 'Active pipeline', key: 'active' },
  { label: 'Hot leads (75+)', key: 'hot' },
  { label: 'Avg lead score', key: 'avgScore' },
]

export default function SummaryBar({ prospects }) {
  const active = prospects.filter(
    (p) => !['Closed Lost', 'Cold'].includes(p.status)
  ).length
  const hot = prospects.filter((p) => p.score >= 75).length
  const avgScore = prospects.length
    ? Math.round(prospects.reduce((a, p) => a + p.score, 0) / prospects.length)
    : 0

  const values = { total: prospects.length, active, hot, avgScore }

  return (
    <div style={styles.grid}>
      {CARD_CONFIG.map(({ label, key }) => (
        <div key={key} style={styles.card}>
          <div style={styles.label}>{label}</div>
          <div style={styles.value}>{values[key]}</div>
        </div>
      ))}
    </div>
  )
}

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 10,
    marginBottom: '1rem',
  },
  card: {
    background: '#f5f5f3',
    borderRadius: 8,
    padding: '12px 14px',
  },
  label: { fontSize: 11, color: '#888', marginBottom: 4 },
  value: { fontSize: 24, fontWeight: 500, color: '#1a1a1a' },
}
